import menu1 from "@/assets/img/menu1.png";
import menu2 from "@/assets/img/menu2.png";
import menu3 from "@/assets/img/menu3.png";
import menu4 from "@/assets/img/menu4.png";
import menu5 from "@/assets/img/menu5.png";

export const NavList = [
  { icon: menu1, name: "政协概况", path: "/list", code: 'zxgk',id: '2001550531400175618'},
  { icon: menu2, name: "政协新闻", path: "/list", code: 'gzdt',id: '2001552237345247233' },
  { icon: menu3, name: "会议活动", path: "/list", code: 'hyhd',id: '2001552927874486274'},
  { icon: menu4, name: "政协工作", path: "/list", code: 'ltgz',id: '2001553564032962562'},
  // { icon: menu5, name: "资政建言", path: "/list", code: 'zzjy',id: '2001553918493593601'},
  // { icon: menu3, name: "党建工作", path: "/list", code: 'djgz',id: '2001554285524553730'},
  { icon: menu3, name: "机关建设", path: "/list", code: 'jgjs',id: '2001554285524553730'},
  // { icon: menu4, name: "文史资料", path: "/list", code: 'wszl',id: '2001555727324942338'},
  { icon: menu5, name: "委员之家", path: "/list", code: 'nbzj',id: '2001556008498499585'}
];
// export const NavList = [
//   { icon: menu1, name: "首页", path: "/home", code: '' },
//   { icon: menu2, name: "人大概览", path: "/overview/list", code: '' },
//   { icon: menu3, name: "新闻中心", path: "/page/list", code: 'xwzx' },
//   { icon: menu4, name: "履职工作", path: "/page/list", code: 'lzgz' },
//   { icon: menu5, name: "信息总览", path: "/page/list", code: 'xxzl' },
// ];